import classes from "./Settings.module.css"
import Select from "react-select"
import { useTranslation } from "react-i18next"
import { default_single_style, generate_brands } from "../../Utils"

const Settings = props => {
    const { t } = useTranslation()
    const brands = generate_brands(t, true)

    const centerStyle = default_single_style()

    return (
        <div className={classes.SettingsContent}>
            <p>{t("misc:Recovery.HaveBrand")}</p>
            <p>
                <strong>{t("translation:LayoutMsg.Cmn_CstBase_00.002")}:</strong>
            </p>
            <Select
                value={props.currentBrand}
                onChange={props.brandChange}
                options={brands}
                styles={centerStyle}
                defaultValue={brands[0]}
                formatOptionLabel={elem => {
                    const url = `https://leanny.github.io/splat3/images/brand/${elem.value}.png`
                    return (
                        <>
                            <img src={url} width="32" alt={elem.label} />
                            <span> {elem.label}</span>
                        </>
                    )
                }}
            />
        </div>
    )
}

export default Settings
